export default {
  /*按钮*/
  bt:{
    search: "Search",
    query:"Query",
    operation:"operation",
    add:"Add",
    edit: "Modify",
    delete: "Delete",
    down: "Download",
    export:"Export",
    upload: "Upload"
  },
  accountDataTable:{
    updateTime: 'Update time:',
    sumAccountReal:'Number of new real accounts',
    sumAccountDemo:'Number of new simulated accounts',
    sumDayAccountReal:'Daily average number of real accounts',
    sumDayAccountDemo:'Average number of simulated accounts per day',
    day:"day",
    weekBy:'weekBy',
    monthBy:'monthBy',
    detail:'detail data',
    export:'export',
    date:'date',
    realCount:'Number of real accounts',
    demoCount:'Number of simulated accounts',
    time:'Opening time',
    advertisingChannel:'Channel source',
    advertisingSeries:'Series source',
    advertisingMj:'Media sources',
  },
  activateDataTable:{
    addActivate:'Number of new activated accounts',
    dayActivate:'Number of activated accounts on the day',
    avgActivate:'Average number of activated accounts per day',
    avgDayActivate:'Daily average number of activated accounts on the same day',
    ratio:'Proportion of activated on the same day',
    activateCount:'Activate account',
    dayActivateCount:'Account activated on the same day',
    oldAccount:'Number of old accounts activated',
    newThan:'Proportion of activated accounts on the same day',
    oldThan:'Proportion of old account activation',
    time:'Activation time',
  },
  depositTable:{
    depositAccount:'Number of deposit accounts',
    depositCount:'Deposit times',
    againDepositionAccount:'Number of redeposited accounts',
    depositAmount:'Deposit amount (USD)',
    avgDeposit:'Number of deposits per capita',
    avgDepositAmount:'Deposit amount per capita (USD)',
    amountAccount:'Number of deposit accounts',
    amountCount:'Deposit times',
    afterDeposit:'Number of redeposited accounts',
    time:'Deposit time',
    inChannel:'All platforms',
    payWay:'Full payment',
  },
  depositMoneyTable:{
    amountMoney:'Deposit amount',
    amountAccountCount:'Number of deposit accounts',
    amountCount:'Deposit times',
  },
  poorTable:{
    withdrawalAccount:'Number of withdrawal accounts',
    withdrawalAmount:'Withdrawal amount (USD)',
    poorAmount:'Margin difference',
    time:'Withdrawal time',
  },
  withdrawalTable:{
    withdrawalCount:'Withdrawal times',
    avgWithdrawal:'Number of withdrawals per capita',
    avgWithdrawalAmount:'Withdrawal amount per capita (USD)',
  },
  realTable:{
    realAccount:'Number of trading accounts',
    realCount:'Number of transactions',
    realHandCount:'Number of transactions',
    againRealHandCount:'Number of transactions per capita',
    dayAvgAccount:'Average number of trading accounts per day',
    time:'Trading hours',
    productType:'tradeConfig type',
    product:'All tradeConfig',
  },
  realProduction:{
    production:'Trading products',
  },
  device:{
    startTime:'Statistical start time',
    endTime:'Statistical deadline',
    type:"Behavior",
    activation: "Status",
    source: "Channel source",
    medium:"Advertising Medium",
    series:"Advertising Series",
    account:"Account",
    enable:"Enable",
    landing: "Login",
    beenActivated: "Activated",
    notActivated: "Not activated",
    deviceVendor: "Device manufacturers ratio",
    model:"Equipment model ratio",
    form: "Operating System ratio",
    version: "System version ratio",
    updateTime: "Update Time",
    vendor:"Manufacturers",
    userCount: "Users",
    userRatio: "User Ratio",
    accessCount: "Times",
    accessRatio: "The ratio of times",
    deviceModel: "Device Model",
    platform:"Operating System",
    osVersion: "System Version",
    other: "Other",
    export:"Export",
    systemAnaly:"system Analy",
    phoneAnaly:"phone Analy",
    phoneSystemAnaly:"phone System Analy",
    appVersionAnaly:"app Version Analy",
    phoneWifiAnaly:"phone Wifi Analy",
    appChannelAnaly:"app Channel Analy",
    md5:"md5",
    networkType:"network Type",
    packageName:"package Name",
    appVerCode:"app Version",
    channel:"channel",
    recordTime:"record Time",
    time:"time",
    ipAdd:"ipAdd",
    recordType:"recordType",
    operates:"操作",
    exportFile:"exportFile",
    faidStr:"設備號",
    androidId:"AndoirdId",
    businessType:"businessType",
    valueOne:"其它信息"
  },
  riskAnalyse: {
    platform: 'Platform',
    accountNo: 'Account No.',
    customerNumber: 'Customer Number',
    activateTime: 'Activation Time',
    referrerNumber: 'Referrer',
    firstTimeCashInCurrency: 'First Deposit Currency',
    totalCashIn: 'Total Deposit',
    totalCashOut: 'Total Withdrawal',
    netCashIn: 'Net Deposit',
    bonusSent: 'Bonus Sent',
    bonusDeducted: 'Bonus Deducted',
    rewardSent: 'Reward Sent',
    rewardDeducted: 'Reward Deducted',
    earnedBonus: 'Earned Bonus',
    totalTrade: 'Total Trades',
    totalVolume: 'Total Volume',
    totalProfit: 'Total Profit',
    highProfitMultiple: 'Profit Multiple (×)',
    totalClearZero: 'Total Clear Zero',
    shortTermTradeRatioPct: 'Short-term Trade Ratio (%)',
    shortTermProfitRatioPct: 'Short-term Profit Ratio (%)',
    top3ProfitableSymbols: 'Top 3 Profitable Symbols',
    openIp: 'Opening IP',
    ipUsageCount: 'IP Shared Count',
    sharedCustomerNumbers: 'IP Shared Accounts',
    ipRegLocationCn: 'IP Region',
    idRegLocationCn: 'ID Region',
    mobilePhoneRegLocationCn: 'Phone Region',
    latestBalance: 'Latest Balance',
    latestEquity: 'Latest Equity',
    latestSettleDate: 'Latest Settle Date',
    queryDays: 'Statistical Days',
    thirtyDays: '30 Days',
    sixtyDays: '60 Days',
    isSharedIp: 'Filter Shared IP',
    yes: 'Yes',
    no: 'No',
    shortTermTradeRatioThreshold: 'Short-term Trade Ratio Threshold',
    shortTermProfitRatioThreshold: 'Short-term Profit Ratio Threshold',
    ipPlaceholder: 'Please enter a valid IPv4 address',
    thresholdPlaceholder: 'Up to 2 decimal places (e.g. 0.15)',
    ipError: 'Invalid Opening IP format. Please enter a valid IPv4 address',
    tradeRatioError: 'Invalid Short-term Trade Ratio Threshold. Must be a number with up to 2 decimal places',
    profitRatioError: 'Invalid Short-term Profit Ratio Threshold. Must be a number with up to 2 decimal places',
    customerAccount: 'Customer Account',
    customerAccountPlaceholder: 'Please enter customer account',
    customerAccountError: 'Invalid customer account format. Please enter a valid integer',
    noRecord: 'No record found',
    customerAccountEmpty: 'Please enter customer account',
    export: 'Export',
    exportMessage: 'If the query data is large, it may take more than 10 seconds to process.',
    exporting: 'Exporting, please wait...',
    exportFailed: 'Export failed',
    exportNetworkError: 'Export failed, please check your network connection',
    customerAccountPlaceholder: 'Enter customer accounts, separated by commas',
    customerAccountLimit: 'You can query up to 200 customer accounts at a time',
    empty: '-',
    totalCommission: 'Total Commission',
    totalSwap: 'Total Swap',
    source: 'Ad Source',
    medium: 'Medium',
    customTime: 'Custom Trade Time',
    threeHundredSixtyFiveDays: '365 Days',
    shortTermSeconds: 'Short-term Def. Seconds',
    uriTooLong: 'Query parameters are too long, please reduce the number of accounts queried at once',
  }
}
